<template>
  <div
    class="notification w-1/4 fixed p-3 pin-t pin-r mt-6 rounded shadow border-white text-white z-40"
    :class="styles"
    style="min-height: 90px"
  >
    <i @click="show = false" title="Close" class="absolute fas fa-times pin-r mr-3 cursor-pointer"></i>
    <h1 class="text-lg mb-2">
      <i class="fas mr-1 fa-sm" :class="toast.icon"></i>
      {{ toast.title }}
    </h1>
    <p class="text-base">{{ toast.info }}</p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      show: false
    }
  },

  computed: {
    ...mapState({
      toast: 'toast'
    }),

    styles () {
      return {
        'bg-green-dark': this.toast.type === 'success',
        'bg-yellow-dark': this.toast.type === 'warning',
        'bg-red-dark': this.toast.type === 'danger',
        'show': this.show
      }
    }
  },

  watch: {
    toast () {
      this.show = true
      setTimeout(() => {
        this.show = false
      }, 5000)
    }
  }
}
</script>

<style lang="sass" scoped>
  .notification
    right: -100%
    transition: right 1s

  .show
    right: 30px
</style>
